import { Clock, Server, UserCircle2 } from 'lucide-vue-next'
import { h } from 'vue'
import { Groups, JSSchema } from '.'
import { Badge } from '../components/ui/badge'
import DeleteButton from '../components/User/DeleteButton.vue'
import EditButton from '../components/User/EditButton.vue'
import { PlatformUserRoles } from '../types/Roles'
import { ColorPalette } from './helpers'
export namespace Users {
  export interface ListItem extends Full {}
  export interface Full {
    userId: string
    email: string
    platformID: string
    insertTime: string
    roles: PlatformUserRoles[]
    lastSeenTime: string
    isTwoFactorEnabled: boolean
  }
}

export const UserGroups = {
  Personal: {
    color: ColorPalette.blue,
    icon: UserCircle2,
    isMainGroup: true,
    mainColumn: 'email',
  },
  Platform: {
    color: ColorPalette.green,
    icon: Server,
    mainColumn: 'platformID',
  },
  Time: {
    color: ColorPalette.black,
    icon: Clock,
    mainColumn: 'insertTime',
  },
} satisfies Groups<Users.Full>

export const UserFullSchema: JSSchema<Users.Full, typeof UserGroups> = {
  name: 'User',
  title: 'Platform User',
  groups: UserGroups,
  fields: {
    userId: {
      type: 'string',
      humanReadable: 'User ID',
      primaryKey: true,
      meta: {
        group: 'Personal',
      },
    },
    email: {
      type: 'string',
      humanReadable: 'Email',
      metaType: 'email',
      sensitive: true,
      meta: {
        group: 'Personal',
      },
    },
    platformID: {
      type: 'string',
      humanReadable: 'Platform ID',
      meta: {
        group: 'Platform',
      },
    },
    lastSeenTime: {
      type: 'date',
      humanReadable: 'Last Seen At',
      meta: {
        group: 'Personal',
      },
    },
    insertTime: {
      type: 'date',
      humanReadable: 'Created',
      isDefaultSortColumn: true,
      meta: {
        group: 'Time',
      },
    },
    roles: {
      type: 'rawArray',
      humanReadable: 'Roles',
      meta: {
        searchable: false,
        sortable: false,
        group: 'Platform',
      },
      values: {
        type: 'string',
        humanReadable: 'Role',
      },
      formattedCell: (values: string[]) => {
        const roles = values.map((role: string) => h(Badge, () => role))
        return h(
          'div',
          {
            class: 'flex flex-wrap gap-1',
          },
          roles
        )
      },
    },
    isTwoFactorEnabled: {
      type: 'boolean',
      humanReadable: '2FA enabled',
    },
  },
  actions: {
    edit: {
      cell: ({ row }) =>
        h(EditButton, {
          user: row.original,
        }),
    },
    delete: {
      cell: ({ row, emits }) =>
        h(DeleteButton, {
          user: row.original,
          onDeleted: () => {
            emits.reload()
          },
        }),
    },
  },
}
